import { IValidationLocalizer } from "./ValidityInterfaces";
import { ValidityStateHelper } from "./ValidityStateHelper";
/**
 * @includeToDoc
 */
export class BasicValidationLocalizer implements IValidationLocalizer {
    protected _locs: Map<string, string> = new Map<string, string>(
        [
            ["VAL-0", "Zadejte prosím validní hodnotu"],
            ["VAL-100", "Zadejte prosím číslo"],
            ["VAL-101", "Zadejte prosím celé číslo"],
            ["VAL-102", "Zadejte prosím datum"],
            ["VAL-103", "Zadejte prosím čas"],
            ["VAL-104", "Zadejte prosím datum a čas"],
            ["VAL-200", "Zadejte hodnotu větší než ${min}"],
            ["VAL-201", "Zadejte hodnotu menší než ${max}"],
            ["VAL-202", "Je nutné zadat hodnotu v rozmezí od ${min} do ${max}"],
            ["VAL-615396", "Všechna pole musí být vyplněna"],
        ] as any,
    );

    public getLocalization(code: string): string {
        const message = this._locs.get(code);
        if (message === undefined)
            return `Unlocalized Validation Error (${code})`; //`

        return message;
    }
}

// zaregistruje se jako defaultni
ValidityStateHelper.validityLocalizer = new BasicValidationLocalizer();
